module.exports = __webpack_public_path__ + "img/conf_travolta.4a06efb5.gif";